export type DisplayRange = {
  min?: string | number;
  max?: string | number;
};

export const formatDisplayRange = ({
  range,
  minimumLabel,
  maximumLabel,
  suffix = '',
  collapseEqualBounds = false,
}: {
  range: DisplayRange;
  minimumLabel: string;
  maximumLabel: string;
  suffix?: string;
  collapseEqualBounds?: boolean;
}): string => {
  const { min, max } = range;
  const hasMin = min !== undefined;
  const hasMax = max !== undefined;

  if (hasMin && hasMax) {
    if (collapseEqualBounds && min === max) {
      return `${min}${suffix}`;
    }

    return `${min} - ${max}${suffix}`;
  }

  if (hasMin) {
    return `${minimumLabel} ${min}${suffix}`;
  }

  if (hasMax) {
    return `${maximumLabel} ${max}${suffix}`;
  }

  return '';
};
